import type { AnyExtension } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';

/**
 * The single extension set behind tiptap_json_v1 rich notes. The web editor and
 * server-side validation/projection must both use exactly this list, so a
 * saved document always means the same thing everywhere.
 */
export function noteExtensions(): AnyExtension[] {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      link: {
        openOnClick: false,
        autolink: true,
        defaultProtocol: 'https',
        protocols: ['http', 'https', 'mailto'],
      },
    }),
  ];
}
